<template>
<v-card style="background-color:antiquewhite">
    <v-card-title class="headline brown darken-4" style="color:white">Give Class Exp
    <v-tooltip right style="margin-right:4px;">
        <template v-slot:activator="{ on, attrs }">
          <v-icon v-bind="attrs" v-on="on" color="white" class="ml-2">help_outline</v-icon>
        </template>
        <span>Players earn experience equal to the CR of the encounter completed on each floor, reduced by 50% if they timed out on each floor. <br/>They earn a floor 4 and 6 token if they complete that respective floor.</span>
      </v-tooltip>
      </v-card-title>
    <table class="ma-4 linedBorder" style="border-collapse: collapse;">
      <tr  style="border-style:solid; border-width:medium; border-color:black"> <td>Player</td> <td>Class</td> <td>Logged In</td>   </tr>           
        <tr v-for="player in players" :key="player.playerName" style="border-style:solid; border-width:medium; border-color:black"> 
            <td>
            <span>{{ player.playerName }}</span>
            </td>     
            <td style="padding-right:16px"> <span v-if="player.characterSheet.characterStats">{{player.characterSheet.characterStats.misc.class}}</span></td>  
            <td v-if="player.username">Yes</td>
            <td v-else>No</td>
        </tr>
    </table>
    
    <v-row class="ml-1">
        <v-col md="3">
            <v-text-field v-model="sendExp" label="Experience Amount"></v-text-field>
        </v-col>
        <v-col md="3">
            <v-checkbox v-model="sendf4Tokens" label="Include Floor 4 Token"></v-checkbox>
        </v-col>
        <v-col md="3">
            <v-checkbox v-model="sendf6Tokens" label="Include Floor 6 Token"></v-checkbox>
        </v-col>
    </v-row>

    <v-btn class="ma-4"  @click="giveExp">Give Exp</v-btn>
</v-card>
</template>
<script>
export default {
  name: "App",
  data() {
    return {
        classes:["fighter","barbarian","rogue","tank","monk","warpriest","eldritchKnight","arcaneTrickster","wizard","cleric","shaman","alchemist","sorcerer","prodigy"],
        tierNames:["tier1","tier2","tier3","tier4","tier5","tier6"],
        tiers:{tier1:0,tier2:0,tier3:0,tier4:0,tier5:0,tier6:0},
        url:
        window.location.href == "http://localhost:8080/"
          ? "http://localhost:7071/api/HttpTrigger1"
          : "/api/HttpTrigger1",
          sendExp:"",
          sendf4Tokens:false,
          sendf6Tokens:false,
          className:"",
    }
  },
  props:{
    username:String,
    password:String,
    players:[]
  },
  methods:{
    giveExp(){
        this.players.forEach(player=>{
            if(player.username && player.characterSheet && player.characterSheet.characterStats.misc.class){
                fetch(this.url, {
                  method: "POST",
                  body: JSON.stringify({
                      command: "giveEXP",
                      username:this.username,
                      password:this.password,
                      targetEmail:player.username,
                      className:player.characterSheet.characterStats.misc.class,
                      amount:this.sendExp,
                      f4Token:this.sendf4Tokens,
                      f6Token:this.sendf6Tokens,
                  }),
                }).then(async (response) => {
                  let responseText = await response.text()
                  console.log("get account response:", responseText)
                })
            }
        })
        if(this.players.length > 0){
          fetch(this.url, {
                  method: "POST",
                  body: JSON.stringify({
                      command: "giveEXP",
                      username:this.username,
                      password:this.password,
                      targetEmail:this.username,
                      className:"universal",
                      amount:this.sendExp,
                      f4Token:false,
                      f6Token:false,
                  }),
                })
        }
    },
  },
}
</script>
<style> 
.linedBorder td{
  border-left:4px; 
  border-right:4px; 
  border-style:solid;
  margin:4px;
  padding:4px;
  text-align:center;
  min-width:150px
}
</style>
